import { SimplePage } from "@/app/_/marketing/SimplePage";
import { Values } from "@/constants";

export default function Page() {
  const email = `support@${Values.URLS["EMAIL"]}`;
  return (
    <SimplePage
      eyebrow="Support"
      title="We're here to help."
      subtitle={`Reach our team at ${email} and we'll get back to you within one business day.`}
      primaryCta={{
        label: "Contact us",
        to: "/company/contact",
      }}
      secondaryCta={{
        label: "Visit help center",
        to: "/resources/help",
      }}
    />
  );
}
